import '../app/App.css';

const lambdaUrl = "https://y49b0wguwk.execute-api.us-west-1.amazonaws.com/Prod/redeemCode";

export const sendLambda = async (code) => {
    try {
        const response = await fetch(lambdaUrl, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ code: code })
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(`HTTP error! status: ${data.code}`);
        }

        console.log('API Response:', data);
        return data;

    } catch (err) {
        console.error('Error calling API:', err);
        return { success: false, message: err.message };
    }
};
